"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _apolloCacheInmemory = require("apollo-cache-inmemory");

var _apolloClient = _interopRequireDefault(require("apollo-client"));

var _apolloLinkContext = require("apollo-link-context");

var _apolloLinkError = require("apollo-link-error");

var _apolloLinkHttp = require("apollo-link-http");

var _axios = _interopRequireDefault(require("axios"));

var _bluebird = _interopRequireDefault(require("bluebird"));

var _lodash = _interopRequireDefault(require("lodash"));

var _nodeFetch = _interopRequireDefault(require("node-fetch"));

var _uuid = _interopRequireDefault(require("uuid"));

var _error = require("./error");

var _binding = _interopRequireDefault(require("./lib/binding"));

var _get_introspection_result = _interopRequireDefault(require("./lib/get_introspection_result"));

var _basic = _interopRequireDefault(require("./_basic"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var BasicDataHubApi =
/*#__PURE__*/
function (_BasicApi) {
  (0, _inherits2.default)(BasicDataHubApi, _BasicApi);

  /**
   * @constructor
   */
  function BasicDataHubApi(_ref) {
    var _this;

    var dataHubUrl = _ref.dataHubUrl,
        userTokenFactory = _ref.userTokenFactory,
        onGraphQLErrors = _ref.onGraphQLErrors,
        onNetworkError = _ref.onNetworkError,
        accountId = _ref.accountId,
        defaultLimit = _ref.defaultLimit,
        accountIdFactory = _ref.accountIdFactory;
    (0, _classCallCheck2.default)(this, BasicDataHubApi);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(BasicDataHubApi).call(this, {
      userTokenFactory: userTokenFactory,
      accountIdFactory: accountIdFactory
    }));
    _this.dataHubUrl = dataHubUrl;
    _this.graphqlUrl = "".concat(dataHubUrl, "/graphql");
    _this.onGraphQLErrors = onGraphQLErrors;
    _this.onNetworkError = onNetworkError;
    _this.accountId = accountId;
    _this.defaultLimit = defaultLimit || 30;

    if (dataHubUrl) {
      var link = (0, _apolloLinkContext.setContext)(function (__, _ref2) {
        var headers = _ref2.headers;
        return _objectSpread({}, headers);
      }).concat((0, _apolloLinkError.onError)(function (_ref3) {
        var graphQLErrors = _ref3.graphQLErrors,
            networkError = _ref3.networkError;

        if (onGraphQLErrors && graphQLErrors) {
          onGraphQLErrors(graphQLErrors);
        }

        if (onGraphQLErrors && networkError) {
          onNetworkError(networkError);
        }
      })).concat((0, _apolloLinkHttp.createHttpLink)({
        uri: _this.graphqlUrl,
        fetch: _nodeFetch.default
      }));
      var client = new _apolloClient.default({
        cache: new _apolloCacheInmemory.InMemoryCache(),
        link: link
      });
      _this.readyStatePromise = (0, _get_introspection_result.default)(client).then(function (_ref4) {
        var data = _ref4.data;
        return new _binding.default({
          introspectionResult: data,
          client: client
        });
      }).catch(function (error) {
        return {
          __error__: error
        };
      });
    }

    _this._createAxios();

    return _this;
  }

  (0, _createClass2.default)(BasicDataHubApi, [{
    key: "getBinding",
    value: function () {
      var _getBinding = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee() {
        var _this2 = this;

        var headers, link, client, binding;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.getHeaders();

              case 2:
                headers = _context.sent;
                link = (0, _apolloLinkContext.setContext)(function (__, _ref5) {
                  var contextHeaders = _ref5.contextHeaders;
                  return _objectSpread({}, contextHeaders, {}, headers);
                }).concat((0, _apolloLinkError.onError)(function (_ref6) {
                  var graphQLErrors = _ref6.graphQLErrors,
                      networkError = _ref6.networkError;

                  if (_this2.onGraphQLErrors && graphQLErrors) {
                    _this2.onGraphQLErrors(graphQLErrors);
                  }

                  if (_this2.onGraphQLErrors && networkError) {
                    _this2.onNetworkError(networkError);
                  }
                })).concat((0, _apolloLinkHttp.createHttpLink)({
                  uri: this.graphqlUrl,
                  fetch: _nodeFetch.default
                }));
                client = new _apolloClient.default({
                  cache: new _apolloCacheInmemory.InMemoryCache(),
                  link: link
                });
                _context.next = 7;
                return this.readyStatePromise;

              case 7:
                binding = _context.sent;

                if (!(binding && binding.__error__)) {
                  _context.next = 10;
                  break;
                }

                throw binding.__error__;

              case 10:
                binding.setClient(client);
                return _context.abrupt("return", binding);

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getBinding() {
        return _getBinding.apply(this, arguments);
      }

      return getBinding;
    }()
  }, {
    key: "_getPaginatedList",
    value: function () {
      var _getPaginatedList2 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee2(methodName, args, projection) {
        var binding, result, resultList, paginatedProjection, currArgs;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.getBinding();

              case 2:
                binding = _context2.sent;
                result = {};
                resultList = [];
                paginatedProjection = projection && projection.length ? _lodash.default.chain(projection).map(function (field) {
                  return "records.".concat(field);
                }).concat('last').value() : ['records', 'last'];

              case 6:
                currArgs = _objectSpread({}, args, {
                  params: _objectSpread({}, args.params, {
                    limit: this.defaultLimit,
                    last: result.last
                  })
                });
                _context2.next = 9;
                return binding.query[methodName](currArgs, paginatedProjection, 'no-cache');

              case 9:
                result = _context2.sent;
                resultList = [].concat((0, _toConsumableArray2.default)(resultList), (0, _toConsumableArray2.default)(result.records));

              case 11:
                if (result.last) {
                  _context2.next = 6;
                  break;
                }

              case 12:
                return _context2.abrupt("return", resultList);

              case 13:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function _getPaginatedList(_x, _x2, _x3) {
        return _getPaginatedList2.apply(this, arguments);
      }

      return _getPaginatedList;
    }()
  }, {
    key: "_getMethodName",
    value: function _getMethodName(name) {
      return this.accountId ? "".concat(name, "CrossAccount") : name;
    }
  }, {
    key: "subscribe",
    value: function () {
      var _subscribe = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee3(requestId) {
        var binding, counter, result;
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (requestId) {
                  _context3.next = 2;
                  break;
                }

                throw new Error('subscription error: requestId is required');

              case 2:
                _context3.next = 4;
                return this.getBinding();

              case 4:
                binding = _context3.sent;
                counter = 0;

              case 6:
                counter++;
                _context3.next = 9;
                return _bluebird.default.delay(1000);

              case 9:
                _context3.next = 11;
                return binding.query.checkExecutionResult({
                  requestId: requestId,
                  hash: _uuid.default.v4()
                });

              case 11:
                result = _context3.sent;

                if (!(result.status !== 'pending')) {
                  _context3.next = 16;
                  break;
                }

                if (!result.error) {
                  _context3.next = 15;
                  break;
                }

                throw result.error;

              case 15:
                return _context3.abrupt("return", result);

              case 16:
                if (counter < 100) {
                  _context3.next = 6;
                  break;
                }

              case 17:
                throw new Error('subscription error: polling is too long');

              case 18:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function subscribe(_x4) {
        return _subscribe.apply(this, arguments);
      }

      return subscribe;
    }()
  }, {
    key: "_callApi",
    value: function () {
      var _callApi2 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee4(_ref7) {
        var _ref7$method, method, _ref7$path, path, payload, queryParams, _ref7$errorData, errorData, errorName, _ref8, headers, _ref9, responseBody;

        return _regenerator.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _ref7$method = _ref7.method, method = _ref7$method === void 0 ? 'GET' : _ref7$method, _ref7$path = _ref7.path, path = _ref7$path === void 0 ? '' : _ref7$path, payload = _ref7.payload, queryParams = _ref7.queryParams, _ref7$errorData = _ref7.errorData, errorData = _ref7$errorData === void 0 ? {} : _ref7$errorData, errorName = _ref7.errorName;
                _context4.next = 3;
                return this.getHeaders();

              case 3:
                _ref8 = _context4.sent;
                headers = _ref8.headers;
                _context4.prev = 5;
                _context4.next = 8;
                return this._axios({
                  method: method,
                  url: path,
                  data: JSON.stringify(payload),
                  params: _lodash.default.mapValues(queryParams, function (value) {
                    return _lodash.default.isArray(value) ? JSON.stringify(value) : value;
                  }),
                  headers: headers
                });

              case 8:
                _ref9 = _context4.sent;
                responseBody = _ref9.data;
                return _context4.abrupt("return", responseBody);

              case 13:
                _context4.prev = 13;
                _context4.t0 = _context4["catch"](5);
                throw new _error.BasicError(_lodash.default.get(_context4.t0, 'response.data.message', _context4.t0), _objectSpread({
                  statusCode: _lodash.default.get(_context4.t0, ['response', 'status']),
                  config: _lodash.default.get(_context4.t0, ['response', 'config']),
                  headers: _lodash.default.get(_context4.t0, ['response', 'headers']),
                  errorData: _lodash.default.get(_context4.t0, 'response.data', _context4.t0)
                }, errorData), errorName);

              case 16:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[5, 13]]);
      }));

      function _callApi(_x5) {
        return _callApi2.apply(this, arguments);
      }

      return _callApi;
    }()
  }, {
    key: "_createAxios",
    value: function _createAxios() {
      var _ref10 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          baseUrl = _ref10.baseUrl;

      this._axios = _axios.default.create({
        baseURL: baseUrl || this.dataHubUrl
      });
    }
  }, {
    key: "defaultLimit",
    get: function get() {
      return this._defaultLimit;
    },
    set: function set(value) {
      this._defaultLimit = value;
    }
  }]);
  return BasicDataHubApi;
}(_basic.default);

var _default = BasicDataHubApi;
exports.default = _default;